import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Comtemplete from "./comtemplete";
import {
  setshowcalllogpage,
  rtcended,
  rtcprocess,
} from "../redux/backgroundpermission/permission-action";
import "../assets/css/dispopage.css";
import {
  Hangup,
  FetchDispo,
  getLeadstatus,
  UpdateLeadstatus,
  rt,
  FetchCustomview,
} from "../redux/apicalling/dispatchfunction";
import { setcallstatus } from "../redux/callstatus/callstatusaction";
import { toast } from "react-toastify";
import { setcutomerinfo } from "../redux/leadinfo/customerinfoaction";

const Disposcreen = (props) => {
  let { action } = props;
  const dispatch = useDispatch();
  const [callNotes, setCallNotes] = useState("");
  const [dispositionStatus, setDispositionStatus] = useState("");
  const [dispostionstate, setDispositionState] = useState("");
  const [leadstatus, setLeadStatus] = useState("");
  const [isDispositionSelected, setIsDispositionSelected] = useState(false);
  const config_api = JSON.parse(localStorage.getItem("config"));
  const userPermission = config_api.projects[0].userPermission;
  const customer_info = useSelector((state) => state.crmcustomerinfo);
  const call_status = useSelector((state) => state.callstatus);
  const [dispositionStatusOptions, setDispositionStatusOptions] = useState("");
  const [leadstatusoptions, setLeadStatusOptions] = useState("");
  const [callPurposeOptions, setCallPurpuseOptions] = useState("");
  const [callPurpose, setCallPurpose] = useState("");
  const [leadStage, setLeadStage] = useState("");
  const [dispoLabel, setDispositionLabel] = useState("");
  const [customModuleName, setcustomModuleName] = useState("");

  // ── Countdown state ──────────────────────────────────────────────
  const countdownEnabled = userPermission?.countdown_dispo === true;
  const dialerInterval = JSON.parse(localStorage.getItem("config")).projects[0].config[0].hangup_seconds || 30;
  const defaultDispo = JSON.parse(localStorage.getItem("config")).projects[0].config[0].default_dispo;

  const [countdown, setCountdown] = useState(dialerInterval);
  const [countdownDone, setCountdownDone] = useState(false);
  const timerRef = useRef(null);
  const hasManuallySubmitted = useRef(false); // track if user already submitted
  // ────────────────────────────────────────────────────────────────

  const agent_name = localStorage.getItem("username");
  const local_customer_info = JSON.parse(localStorage.getItem("customer_info"));

  // ── Countdown logic ──────────────────────────────────────────────
  useEffect(() => {
    if (!countdownEnabled) return;

    setCountdown(dialerInterval);

    timerRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setCountdownDone(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [countdownEnabled, dialerInterval]);

  // When countdown finishes — auto submit only if user hasn't submitted manually
  useEffect(() => {
    if (countdownDone && !hasManuallySubmitted.current) {
      submitPayload(defaultDispo, defaultDispo);
    }
  }, [countdownDone]);
  // ────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (userPermission.auto_dispo == false) {
      let customField = true;
      fetchDispo(customField);
      if (userPermission.customModule) {
        fetchDispo(customField, userPermission.customModule);
      }
    }
    if (userPermission.dialer_subFilter1 && !userPermission.crm_call_purpose) {
      fetchLeadstatus();
    }
    if (userPermission.crm_call_purpose) {
      fetchCallPurpuse();
    }
  }, []);

  const fetchCallPurpuse = () => {
    dispatch(FetchCustomview()).then((response) => {
      if (response.status === 200) {
        setCallPurpuseOptions(response.data.data);
        if (response.data.module) {
          setcustomModuleName(response.data.module);
        }
      }
    });
  };

  const handleCallNotesChange = (event) => {
    setCallNotes(event.target.value);
  };

  const handleDispositionStatusChange = (event) => {
    const selectElement = event.target;
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const selectedValue = selectedOption.value;
    const selectedLabel = selectedOption.text;
    const [value, state] = selectedValue.split(" - ");
    setDispositionState(state || null);
    setDispositionStatus(selectedValue);
    setIsDispositionSelected(!!selectedValue);
    setDispositionLabel(selectedLabel);
  };

  const handleleadstatusChange = (event) => {
    const selectedStatus = event.target.value;
    setLeadStatus(selectedStatus);
  };

  const fetchDispo = async (customField, customModule) => {
    let condition = {
      crm_call_purpose: userPermission.crm_call_purpose,
      customModule: customModule,
      customField: customField,
    };
    dispatch(FetchDispo(condition))
      .then((response) => {
        if (response.status === 200) {
          const extractedStatuses = response.data.data;
          let dispoobjdecode = Object.values(extractedStatuses);
          const dispoarraydecode = dispoobjdecode.map((dispo) => dispo.label);
          if (customModule) {
            setCallPurpuseOptions(extractedStatuses);
          } else {
            setDispositionStatusOptions(extractedStatuses);
          }
          dispatch(setcallstatus(dispoarraydecode));
        }
      })
      .catch((err) => err);
  };

  const fetchLeadstatus = async () => {
    let payload = {};
    if (userPermission.modulebased_status && local_customer_info.module) {
      payload.module = local_customer_info.module;
    }
    dispatch(getLeadstatus(payload))
      .then((response) => {
        if (response.status === 200) {
          const extractedleadStatus = response.data.data;
          console.log("lead status66", extractedleadStatus);
          setLeadStatusOptions(extractedleadStatus);
        }
      })
      .catch((err) => err);
  };

  // ── Shared submit payload ────────────────────────────────────────
  const submitPayload = (overrideDispoStatus, overrideDispoLabel) => {
    const finalDispoStatus = overrideDispoStatus ?? dispositionStatus;
    const finalDispoLabel = overrideDispoLabel ?? dispoLabel;

    const payload = {
      station: config_api.projects[0]?.userInfo[0].user_phone_number,
      phone_number: local_customer_info?.customer_number,
      entity_type: local_customer_info?.module,
      user_id: config_api.projects[0]?.userInfo[0].user_id,
      customer_id: local_customer_info?.customer_id,
      caseId: local_customer_info?.case_id,
      agent: { identity: "user", value: agent_name },
      call_status: { label: finalDispoLabel, value: finalDispoStatus },
      call_state: dispostionstate,
      description: callNotes,
      customer_name:
        local_customer_info?.customer_name !== undefined
          ? local_customer_info.customer_name
          : "Unknown Name",
      call_type: local_customer_info?.call_type,
      lead_status: leadstatus,
      lead_state: leadstatus,
      lead_view:
        callPurpose !== "" ? callPurpose : local_customer_info?.lead_view,
      Lead_Stage:
        leadStage !== "" ? leadStage : local_customer_info?.lead_stage,
      lead_id: local_customer_info?.customer_id,
    };

    dispatch(Hangup(payload))
      .then((disporesponse) => {
        if (disporesponse.status === 200) {
          let cleared_customer_info = {
            response_status: "",
            customer_name: "",
            customer_number: "",
            module: "",
            customer_id: "",
            customer_leadstatus: "",
            customer_leadowner: "",
            call_type: "",
            StatusFlag: false,
          };
          dispatch(setcutomerinfo(cleared_customer_info));
          localStorage.removeItem("customer_info");
          localStorage.setItem("livecall", false);
          localStorage.removeItem("callerinfo");
          localStorage.removeItem("livecall");
          dispatch(setshowcalllogpage(true));
          dispatch(rtcended(false));
          dispatch(rtcprocess(true));
          const callOutcome = local_customer_info.call_outcome;
          action("dispo", callOutcome);
        }
      })
      .catch((err) => err);
  };
  // ────────────────────────────────────────────────────────────────

  const handleSubmit = () => {
    try {
      // Stop the countdown timer — user submitted manually
      clearInterval(timerRef.current);
      hasManuallySubmitted.current = true;

      submitPayload();

      setCallNotes("");
      setDispositionStatus("");
      setDispositionState("");
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };

  const handleCallPurposeChange = (e) => setCallPurpose(e.target.value);
  const handleLeadStageChange = (e) => setLeadStage(e.target.value);

  // ── Circular countdown SVG ───────────────────────────────────────
  const CircularCountdown = ({ current, total }) => {
    const radius = 36;
    const circumference = 2 * Math.PI * radius;
    const progress = (current / total) * circumference;

    return (
      <div style={styles.countdownWrapper}>
        <svg width="90" height="90">
          <circle
            cx="45" cy="45" r={radius}
            fill="none" stroke="#e0e0e0" strokeWidth="7"
          />
          <circle
            cx="45" cy="45" r={radius}
            fill="none" stroke="#4a90e2" strokeWidth="7"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            strokeLinecap="round"
            transform="rotate(-90 45 45)"
            style={{ transition: "stroke-dashoffset 1s linear" }}
          />
          <text
            x="45" y="51"
            textAnchor="middle"
            fontSize="20" fontWeight="bold" fill="#333"
          >
            {current}
          </text>
        </svg>
        <p style={styles.countdownText}>
          Auto-submitting in <strong>{current}s</strong> with default dispo
        </p>
      </div>
    );
  };
  // ────────────────────────────────────────────────────────────────

  return (
    <div>
      <Comtemplete waitingCalls={props.waitingCalls}>
<div style={styles.scrollContainer}>
        {/* ── Countdown ring (only when enabled and still ticking) ── */}
        {countdownEnabled && !countdownDone && (
          <CircularCountdown current={countdown} total={dialerInterval} />
        )}

        {/* ── Dispo form — always visible ─────────────────────────── */}
        <div>
          <div>
            <div className="call-notes">
              <textarea
                rows="4"
                value={callNotes}
                onChange={handleCallNotesChange}
                placeholder="Add call notes here"
              ></textarea>
            </div>

            {userPermission.dialer_subFilter1 &&
              local_customer_info?.StatusFlag ||
              ((local_customer_info?.case_id !== undefined &&
                local_customer_info?.case_id !== "") ||
                (local_customer_info?.customer_id !== undefined &&
                  local_customer_info?.customer_id !== "")) &&
                !userPermission.crm_call_purpose && (
                  <div className="leadstatus-status-dropdown">
                    <select
                      id="leadStatus"
                      value={leadstatus}
                      onChange={handleleadstatusChange}
                      className="white-select"
                    >
                      <option value="">
                        Select{" "}
                        {leadstatusoptions.module
                          ? leadstatusoptions.module
                          : local_customer_info == null
                          ? ""
                          : local_customer_info.module}{" "}
                        Status
                      </option>
                      {Array.isArray(leadstatusoptions) ? (
                        leadstatusoptions.map((option, index) => {
                          const combinedValue =
                            option.state !== null &&
                            option.state !== undefined &&
                            option.state !== ""
                              ? `${option.value} - ${option.state}`
                              : option.value;
                          return (
                            <option key={index} value={combinedValue}>
                              {option.label}
                            </option>
                          );
                        })
                      ) : (
                        <option value="No Data">No Data</option>
                      )}
                    </select>
                  </div>
                )}

            {userPermission.crm_call_purpose && (
              <div className="leadstatus-status-dropdown">
                <select
                  id="callPurpose"
                  value={callPurpose}
                  onChange={handleCallPurposeChange}
                  className="white-select"
                >
                  <option value="">
                    Select {customModuleName || "Call purpose"}
                  </option>
                  {Array.isArray(callPurposeOptions) ? (
                    callPurposeOptions.map((option, index) => (
                      <option key={index} value={option.label}>
                        {option.label}
                      </option>
                    ))
                  ) : (
                    <option value="No Data">No Data</option>
                  )}
                </select>
              </div>
            )}

            {userPermission.customModule && (
              <div className="leadstatus-status-dropdown">
                <select
                  id="leadStage"
                  value={leadStage}
                  onChange={handleLeadStageChange}
                  className="white-select"
                >
                  <option value="">Select Lead Stage</option>
                  {Array.isArray(callPurposeOptions) ? (
                    callPurposeOptions.map((option, index) => (
                      <option key={index} value={option.label}>
                        {option.label}
                      </option>
                    ))
                  ) : (
                    <option value="No Data">No Data</option>
                  )}
                </select>
              </div>
            )}

            {userPermission.dialer_subFilter2 && (
              <div className="disposition-status-dropdown">
                <select
                  id="dispositionStatus"
                  value={dispositionStatus}
                  onChange={handleDispositionStatusChange}
                  className="white-select"
                >
                  <option value="">Select Disposition Status</option>
                  {Array.isArray(dispositionStatusOptions) ? (
                    dispositionStatusOptions.map((option, index) => {
                      const combinedValue =
                        option.state !== null &&
                        option.state !== undefined &&
                        option.state !== ""
                          ? `${option.value} - ${option.state}`
                          : option.value;
                      return (
                        <option key={index} value={combinedValue}>
                          {option.label}
                        </option>
                      );
                    })
                  ) : (
                    <option value="No Data">No Data</option>
                  )}
                </select>
              </div>
            )}
          </div>

          <button
            type="button"
            className="dispo-button"
            onClick={handleSubmit}
            disabled={dispositionStatus.length === 0}
          >
            Submit
          </button>
        </div>
</div>
      </Comtemplete>
    </div>
  );
};

const styles = {
   scrollContainer: {
    height: "calc(100vh - 120px)", // adjust based on header/footer
    overflowY: "auto",
    padding: "10px"
  },
  countdownWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "16px 0 8px",
    gap: "8px",
  },
  countdownText: {
    margin: 0,
    fontSize: "13px",
    color: "#555",
    textAlign: "center",
  },
};

export default Disposcreen;